// extracted by mini-css-extract-plugin
module.exports = {"cancel":"ActionButtons_cancel__1jb62","btn_create_shipment":"ActionButtons_btn_create_shipment__18me8"};